export default __webpack_public_path__ + "static/media/support 2.af18fde6.svg";